import Dexie from 'dexie';
import 'core-js/es6/array';

export class AbstractRepository extends Dexie {
    schema = {
        content: '++id,type,title,description,additionalData,image1,image2,image3,image4,image5,codeType,*tags',
        tags: '++id,title,parent',
        box: '++id,type,title,parent,color,selected,dashboard,active,hidden',
        link: '++id,color,title,href,box',
        config: '++id,code,type,value,foreign,title,description,cols'
    };

    constructor() {
       super('My Knowledge');
       this.close();
       this.version(6).stores(this.schema);
       this.open();

    }

    async changeSchema() {

        this.close();
        const newDb = new Dexie(this.name);

        newDb.on('blocked', ()=>false); // Silence console warning of blocked event.

        // Workaround: If DB is empty from tables, it needs to be recreated
        if (this.tables.length === 0) {
            await this.delete();
            newDb.version(1).stores(this.schema);
            return await newDb.open();
        }

        // Extract current schema in dexie format:
        const currentSchema = this.tables.reduce((result,{name, schema}) => {
            result[name] = [
                schema.primKey.src,
                ...schema.indexes.map(idx => idx.src)
            ].join(',');
            return result;
        }, {});

        console.log("Version: " + this.verno);
        console.log("Current Schema: ", currentSchema);

        // Tell Dexie about current schema:
        newDb.version(this.verno).stores(currentSchema);
        // Tell Dexie about next schema:
        newDb.version(this.verno + 1).stores(this.schema);
        // Upgrade it:
        await newDb.open();
    }
}